export const FIXED_STICKY_FOOTER_HEIGHT = 85;
export const FIXED_TOAST_HEIGHT = '50px';
